//tabs driven by core js.
/* global mzFunc mzMenu mzTabs */

import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { goToTop, getBaseUrl, getParams, getLoading, setCursorWaiting, province, hideCmsHiddenBlock } from "../../../utils";

import SummaryCalculator from '../../../Helpers/summarycalculator';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { FinanceOptions } from '../../2_Molecules/FinanceOptions/FinanceOptions';
import { LeaseOptions } from '../../2_Molecules/LeaseOptions/LeaseOptions';
import { CashOptions } from '../../2_Molecules/CashOptions/CashOptions';
import { PricePayment } from '../../2_Molecules/PricePayment/PricePayment';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { Alert } from '../../3_Organisms/Alert/Alert';
import ReactHtmlParser from 'react-html-parser';

export const PaymentsPage = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation(['payments', 'general']);
    const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = React.useState(null);
    let hasScrolled = false;
    const navigate = useNavigate();
    const [visibleTab, setVisibleTab] = useState(t("payments:finance_options"));
    //const [openCollapsable, setOpenCollapsable] = useState(null);
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalPaymentInformation));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const [selectedFinanceOption, setSelectedFinanceOption] = useState(null);
    const [selectedLeaseOption, setSelectedLeaseOption] = useState(null);
    const [selectedLeaseMileage, setSelectedLeasesMileage] = useState(null);
    
    const [loyaltyChecked, setLoyaltyChecked] = useState(summaryCalculator.LoyaltyChecked);
    const [graduateChecked, setGraduateChecked] = useState(summaryCalculator.GraduateChecked);
    const [militaryChecked, setMilitaryChecked] = useState(summaryCalculator.MilitaryChecked);
    const [firstTimeOwnerChecked, setFirstTimeOwnerChecked] = useState(summaryCalculator.FirstTimeOwnerChecked);
    const [includeFeesChecked, setIncludeFeesChecked] = useState(summaryCalculator.IncludeFees);
    const [includeTaxesChecked, setIncludeTaxesChecked] = useState(summaryCalculator.IncludeTaxes);
    const [includeRebatesChecked, setIncludeRebatesChecked] = useState(summaryCalculator.IncludeRebates);

    const [tradeInValue, setTradeInValue] = useState(summaryCalculator.TradeInValue);
    const [downPaymentValue, setDownPaymentValue] = useState(summaryCalculator.DownPaymentValue);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);

    const [financialInfo, setFinancialInfo] = useState(summaryCalculator.FinancialInfo);

    const [searchParams, setSearchParams] = useSearchParams();
    const DEBUG_MODE = sessionStorage.getItem(Constants.DEBUG);

	const baseURL =  getBaseUrl() + '/globalassets/mazda-canada/build-and-price/pricing/evgridicons/';

    const [financeType, setFinanceType] = React.useState(false);

	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    if(getParams()['tve']){
        console.log(getParams()['tve'][0]);
    }
    
    if (DEBUG_MODE)
        console.log('YOU ARE IN DEBUG!');

    let legalContentObject = '';
    if (legalContentObject) {
        legalContentObject.map(item => {
            legalContent += item.copy
        });
    }

    if (DEBUG_MODE) {
        console.log(summaryCalculator.SelectedModelYear);

        console.log('mazdaCashIncentive', summaryCalculator.FinancialInfo.mazdaCashIncentive);
    }

    async function setDownPaymentInput(e) {
        const el = e.target;

        let val = e.target.value;
        val = val.replace(/\D/g, "");

        if (!DEBUG_MODE) {
            // downpayment : Min: 0 , Max:  (TotalMSRP-10000) 
            if(parseInt(val) +  summaryCalculator.FinancialInfo.tradeInValue >= summaryCalculator.FinancialInfo.maxDownPayment){
                val = summaryCalculator.FinancialInfo.maxDownPayment -summaryCalculator.FinancialInfo.tradeInValue;
            }else if(parseInt(val) > summaryCalculator.FinancialInfo.maxDownPayment){
                val = summaryCalculator.FinancialInfo.maxDownPayment;
            }
        }

        if (val.length > 0) {
            summaryCalculator.DownPaymentValue = `$${val}`;
        } else {
            summaryCalculator.DownPaymentValue = val;
        }

        // Check if the balance is under 7500$, if so update the downpayment
        if(summaryCalculator.IncludeFees ? (summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinance < 7500 || summaryCalculator.FinancialInfo.calculatedLease.leaseEndValue < 3000) : (summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceNoFees < 7500 || summaryCalculator.FinancialInfo.calculatedLease.leaseEndValueNoFees < 3000) ) {
            summaryCalculator.TradeInValue = 0;
            summaryCalculator.DownPaymentValue = 0;
        }

        setDownPaymentValue(summaryCalculator.DownPaymentValue);
    }  

    async function checkTradeInValue(tempVal){
        console.log('checkTradeInValue', tempVal);
        let val = tempVal;
        if(typeof val==='string'){
            val = tempVal.replace(/\D/g, "");
        }
        if (!DEBUG_MODE) {
            // Tradein : Min: 0 , Max:  (TotalMSRP-10000) 
            if(parseInt(val) > summaryCalculator.FinancialInfo.maxDownPayment){
                val = summaryCalculator.FinancialInfo.maxDownPayment;
                summaryCalculator.DownPaymentValue = 0;
            }else if(parseInt(val) +  summaryCalculator.FinancialInfo.downPaymentValue > summaryCalculator.FinancialInfo.maxDownPayment){
                summaryCalculator.DownPaymentValue = summaryCalculator.FinancialInfo.maxDownPayment - parseInt(val);
            }
        }

        if (val.length > 0) {
            summaryCalculator.TradeInValue = `$${val}`;
        } else {
            summaryCalculator.TradeInValue = val;
        }

        // Check if the balance is under 7500$, if so update the downpayment
        if(summaryCalculator.IncludeFees ? (summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinance < 7500 || summaryCalculator.FinancialInfo.calculatedLease.leaseEndValue < 3000) : (summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceNoFees < 7500 || summaryCalculator.FinancialInfo.calculatedLease.leaseEndValueNoFees < 3000) ) {
            summaryCalculator.TradeInValue = 0;
            summaryCalculator.DownPaymentValue = 0;
        }

        setTradeInValue(summaryCalculator.TradeInValue);
    }
    async function onBlurDownPaymentInput(e) {
        setCursorWaiting(true);

        setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());

        gtmHelper.setGTM({'action':'Input', 'type': 'down payment', 'value': e.target.value}, true , false);
        
        setCursorWaiting(false);
    }
    async function setTradeInInput(e) {
        setCursorWaiting(true);
        
        checkTradeInValue(e.target.value);
        setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());
    }  
    async function onBlurTradeInInput(e) {
        setCursorWaiting(true);

        setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());

        gtmHelper.setGTM({'action':'Input', 'type': 'trade in', 'value': e.target.value}, true , false);
        
        setCursorWaiting(false);
    }    

    hideCmsHiddenBlock();

    summaryCalculator.CurrentStep = 8;
    
    React.useEffect(() => {
        async function executeTasks() {
            if (!summaryCalculator.isDataLoaded()/* && !loading*/) {
                await summaryCalculator.loadVehicleData(year, carline, trim, model, packageCode);

                if (JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError)) === true) {
                    const vehiclePageUri = `/${decodeURI(window.location.search)}`;
                    navigate(vehiclePageUri)
                }

                setNav(null);

                await summaryCalculator.loadFromFinancialProvider();
            }

            if (nav === null) {
                //setNav(navHelper.getNavContent(year, carline, trim, model, packageCode,summaryCalculator.CurrentStep, t));
                const toRender = navHelper.getNavContent(t);
                setNav(toRender);
            }

            // patch for the ctrl-r case
            //await summaryCalculator.loadFromFinancialProvider();
            
            if (loading) {
                setLoading(false);
            }

            if (getParams()['tve'] !== undefined){
                checkTradeInValue(getParams()['tve'][0]);
                searchParams.delete('tve');
                setSearchParams(searchParams)
                
                setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());
            }
        }
		if(typeof mzFunc === 'object' && typeof mzTabs === 'object'){
			mzFunc.waitForEl('.mzBuildandPrice .mz-tabs').then(function(components){mzTabs.init(components);});
            // TODO: Verify why it doesn't work on mobile
            //mzMenu.init();
		}
        
        executeTasks();
    }, [nav, searchParams, summaryCalculator, financialInfo, selectedFinanceOption, selectedLeaseOption, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, includeFeesChecked, includeTaxesChecked, includeRebatesChecked, tradeInValue, downPaymentValue]);

    React.useEffect(() => {
        if( document.querySelector('#oca') != undefined){
            if (searchParams.get('oca') === '1') {
                document.querySelector('#oca').scrollIntoView({
                    block: 'center',
                    behavior: 'smooth'
                });
            }
        }

    },[searchParams, loading]);

    function nextStep() {
        goToTop();
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/summary${decodeURI(window.location.search)}`);
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

    let paymentCats = [{ name: t("payments:finance_options") }, { name: t("payments:lease_options") }, { name: t("payments:purchase_price") }];

    const paymentTabs = Object.keys(paymentCats).map((item, key) => {
        return (
            <a
                onClick={() => setVisibleTab(paymentCats[item].name)}
                key={paymentCats[item].name}
                className={visibleTab === paymentCats[item].name ? "mz-tabs-tab interactive active" : "mz-tabs-tab interactive"}
            >
                {paymentCats[item].name}
            </a>
        )
    });

    let paymentBlocks = [{ name: t("payments:finance_options"), class: 'mz-finance-options' }, { name: t("payments:lease_options"), class: 'mz-lease-options' }, { name: t("payments:purchase_price"), class: 'mz-detailed-options' }];
    const paymentTabsContent = Object.keys(paymentBlocks).map((item, key) => {

        return (
            <div
                key={key}
                className="mz-payments-page__details__column"
                style={paymentBlocks[item].name.includes(visibleTab) ? {} : { display: 'none' }}
            >   
                {item==='0' ? <div><FinanceOptions setSelectedFinanceOption={ setSelectedFinanceOption } setPreorderModalOpen={setPreorderModalOpen} /></div> : '' }
                {item==='1' ?  <div><LeaseOptions setSelectedLeaseOption={ setSelectedLeaseOption } setSelectedLeasesMileage={ setSelectedLeasesMileage }  setPreorderModalOpen={setPreorderModalOpen} /></div> : '' }
                {item==='2' ? <div><CashOptions />
                </div> : '' }
            </div>
        )
    });

    function getAdminFeeDisclaimerSection() {
        const el = document.querySelectorAll('input[data-mz-form-field-name="formAdminServiceFeeDisclaimer"]');

        const disclaimerMessage = el.length > 0 ? el[0].value : "";

        if(disclaimerMessage)
            return (
                    <div className="mz-admin-fee-disclaimer">
                        {disclaimerMessage}
                    </div>
            );
        else
            return (
                <>
                </>
            );
    }

    async function handleLoyaltyChecked() {
        setCursorWaiting(true);

        summaryCalculator.LoyaltyChecked  = !summaryCalculator.LoyaltyChecked;
        if(summaryCalculator.LoyaltyChecked)
            summaryCalculator.FirstTimeOwnerChecked = false;

        await summaryCalculator.RecalculateFinancialInfo();
        setLoyaltyChecked(summaryCalculator.LoyaltyChecked);
        setFirstTimeOwnerChecked(summaryCalculator.FirstTimeOwnerChecked);

        setCursorWaiting(false);
    }

    async function handleFirstTimeOwnerChecked() {
        setCursorWaiting(true);

        summaryCalculator.FirstTimeOwnerChecked  = !summaryCalculator.FirstTimeOwnerChecked;
        if(summaryCalculator.FirstTimeOwnerChecked)
            summaryCalculator.LoyaltyChecked = false;

        await summaryCalculator.RecalculateFinancialInfo();
        setFirstTimeOwnerChecked(summaryCalculator.FirstTimeOwnerChecked);
        setLoyaltyChecked(summaryCalculator.LoyaltyChecked);

        setCursorWaiting(false);
    }    

    async function handleGraduateChecked() {
        setCursorWaiting(true);

        summaryCalculator.GraduateChecked  = !summaryCalculator.GraduateChecked;
        await summaryCalculator.RecalculateFinancialInfo();
        setGraduateChecked(summaryCalculator.GraduateChecked);

        setCursorWaiting(false);
    }

    async function handleMilitaryChecked() {
        setCursorWaiting(true);

        summaryCalculator.MilitaryChecked  = !summaryCalculator.MilitaryChecked;
        await summaryCalculator.RecalculateFinancialInfo();
        setMilitaryChecked(summaryCalculator.MilitaryChecked);

        setCursorWaiting(false);
    }



    async function handleIncludeFeesChecked() {
        setCursorWaiting(true);

        summaryCalculator.IncludeFees = !summaryCalculator.IncludeFees;
        await summaryCalculator.RecalculateFinancialInfo();
        setIncludeFeesChecked(summaryCalculator.IncludeFees);

		gtmHelper.setGTM({'action':'Checkbox', 'type': 'Fees', 'value': summaryCalculator.IncludeFees}, true , false);

        setCursorWaiting(false);
    }

    async function handleIncludeTaxesChecked() {
        setCursorWaiting(true);

        summaryCalculator.IncludeTaxes = !summaryCalculator.IncludeTaxes;
        await summaryCalculator.RecalculateFinancialInfo();
        setIncludeTaxesChecked(summaryCalculator.IncludeTaxes);

		gtmHelper.setGTM({'action':'Checkbox', 'type': 'Taxes', 'value': summaryCalculator.IncludeTaxes}, true , false);

        setCursorWaiting(false);
    }

    async function handleIncludeRebatesChecked() {
        setCursorWaiting(true);

        summaryCalculator.IncludeRebates = !summaryCalculator.IncludeRebates;
        await summaryCalculator.RecalculateFinancialInfo();
        setIncludeRebatesChecked(summaryCalculator.IncludeRebates);
        

		gtmHelper.setGTM({'action':'Checkbox', 'type': 'Rebates', 'value': summaryCalculator.IncludeRebates}, true , false);

        setCursorWaiting(false);
    }
 
    function hasAlertBar() {
        return summaryCalculator?._selectedModelYear?.incentives_banner || summaryCalculator?._selectedTrim?.incentives_banner;
    }

    function canDisplayEvRebatesCheckBox() {
        return summaryCalculator.FinancialInfo.ev_rebates && summaryCalculator.FinancialInfo.ev_rebates.length > 0;
    }

    if (loading) {
        return (
            <div className="mz-spinner">LOADING ...</div>
        )
    }
    return (
        <>
            {getLoading(loading, t)}
            <Nav nav={nav} />
            <div className={`${hasAlertBar() ? 'mz-top-nav-spacing' : ''}`}>
                <Alert />
                <div className={`mz-payments-page ${hasAlertBar() ? 'alert-bar-top' : 'mz-top-nav-spacing'}`}>
                    <PricePayment title={summaryCalculator.VehicleTitle}
                    incentives={summaryCalculator.Incentives}
                    ev_rebates={summaryCalculator.FinancialInfo.ev_rebates}
                    tradeInValue={summaryCalculator.TradeInValue}
                    downPaymentValue={summaryCalculator.DownPaymentValue}
                    loyaltyChecked={summaryCalculator.LoyaltyChecked}
                    graduateChecked={summaryCalculator.GraduateChecked}
                    militaryChecked={summaryCalculator.MilitaryChecked}
                    firstTimeOwnerChecked={summaryCalculator.FirstTimeOwnerChecked}
                    setDownPaymentInput={setDownPaymentInput}
                    onBlurDownPaymentInput={onBlurDownPaymentInput}
                    setTradeInInput={setTradeInInput}
                    onBlurTradeInInput={onBlurTradeInInput}
                    setLoyaltyChecked={handleLoyaltyChecked}
                    setGraduateChecked={handleGraduateChecked}
                    setMilitaryChecked={handleMilitaryChecked}
                    setFirstTimeOwnerChecked={handleFirstTimeOwnerChecked}
                    checkTradeInValue={checkTradeInValue}
                    setFinancialInfo={setFinancialInfo} />
                    {ReactHtmlParser(summaryCalculator.SelectedModelYear.price_payments_callout)}
                    
                    { searchParams.get('oca') === '1' ?
                        <>
                            <div class="mz-spacer mz-spacer-s"></div>
                            <div class="mz-payments-page__details mz-container-flex mz-bg--black" id="oca">
                                <div class="mz-flex-1">
                                    <div class="mz-spacer mz-spacer-s"></div>
                                    <h4 class="text--white text--center">{t('creditTitle')}</h4>
                                    <p class="text--white text--center">{t('creditContent')}</p>
                                </div>
                            </div>
                        </>
                        : ''
                    }
                    <div className="mz-financial--actions">
                        {canDisplayEvRebatesCheckBox() ? 
                        <div className="actions__item">
                            <input type="checkbox" defaultChecked={summaryCalculator.IncludeRebates} onChange={handleIncludeRebatesChecked} id="includeRebates" />
                            <label htmlFor="includeRebates"> {t("checkbox_include_government_rebates")}</label>
                        </div> : null }
                        <div className="actions__item">
                            <input type="checkbox" defaultChecked={summaryCalculator.IncludeFees} onChange={handleIncludeFeesChecked} id="includeFees" />
                            <label htmlFor="includeFees"> {t("checkbox_include_fees_and_levies")}</label>
                        </div>
                        <div className="actions__item">
                            <input type="checkbox" defaultChecked={summaryCalculator.IncludeTaxes} onChange={handleIncludeTaxesChecked} id="includeTaxes" />
                            <label htmlFor="includeTaxes"> {t("checkbox_include_taxes_in_prices")}</label>
                        </div>

                    </div>

                    {getAdminFeeDisclaimerSection()}
                    
                    <div className="mz-payments-page__details">
                        <div className="mz-tabs mz-tabs--payments mz-mobile">
                            <div className="mz-tabs-menu">
                                <div className="mz-tabs-menu-container">
                                <div className="mz-tabs-menu-inner">
                                        {paymentTabs}
                                    </div>
                                </div>
                                <div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel mz-svg--rotate180"></i></div>
                                <div className="mz-tabs-menu--right active"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel"></i></div>
                            </div>
                            <div className="mz-tabs__content">
                                {paymentTabsContent}
                            </div>
                        </div>
                    </div>
                    <div className="mz-legal mz-mobile">
                        <Button
                            className="mz-btn mz-btn--legal text--grey"
                            label={t("general:legal")}
                            backgroundColor="grey"
                            colour="grey"
                            icon={true}
                            iconAfter={true}
                            svg_className=""
                            svg_list="plus"
                            size={0.6}
                            onClick={() => {
                                document.querySelector('body').classList.add('disabled');
                                setLegalModalOpen(true);
                            }}
                        />
                    </div>
                    <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" buttonLabel={t("general:next_summary")} saveLabel={t("general:save_build")} summaryCalculator={summaryCalculator}
                        HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} setPreorderModalOpen={setPreorderModalOpen}/>
                    <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
                    <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
                </div>
            </div>
        </>
    )
}

export default PaymentsPage;